import React from "react";

const FormStep = (props) => {
  const { stepName, validationSchema, onSubmit, children } = props;
  return <>{children}</>;
};

export default FormStep;
